import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";

export default function DetalhesClienteModal({ cliente, isOpen, onClose }) {
  if (!cliente) return null;

  const InfoItem = ({ label, value }) => (
    <div>
      <p className="text-sm font-medium text-gray-500">{label}</p>
      <p className="text-md text-gray-900">{value || 'Não informado'}</p>
    </div>
  );
  
  // Função para formatar CPF (123.456.789-10)
  const formatCPF = (cpf) => {
    if (!cpf) return '';
    return cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
  };

  // Função de formatação de data mais segura
  const formatDate = (dateString) => {
    if (!dateString) return 'Não informada';
    const date = new Date(dateString);
    if (isNaN(date.getTime())) { // Verifica se a data é válida
      return 'Data inválida';
    }
    return date.toLocaleDateString('pt-BR', { timeZone: 'UTC' });
  };

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle>{cliente.nome}</DialogTitle>
          <DialogDescription>
            Detalhes completos do cliente.
          </DialogDescription>
        </DialogHeader>
        
        <div className="grid gap-4 py-4">
            <InfoItem label="Nome Completo" value={cliente.nome} />
            <InfoItem label="CPF" value={formatCPF(cliente.cpf)} />
            <InfoItem label="Email" value={cliente.email} />
            <InfoItem label="Telefone" value={cliente.telefone} />
            <InfoItem label="Data de Nascimento" value={formatDate(cliente.data_nascimento)} />
        </div>

        <DialogFooter>
          <Button onClick={onClose}>Fechar</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
